<template >
  <div style="margin-left: 20px;margin-right: 20px">
    <h3>Profile</h3>
    <el-row :gutter="20" >
      <el-col :xs="24" :sm="24" :md="8" :lg="8" >
        <el-card class="box-card">
          <img :src="selected.avatar_path" class="image">
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="24" :md="16" :lg="16" >
        <el-card class="box-card">
          <el-tabs v-model="activeName" >
            <el-tab-pane label="Info" name="first">
              <el-form ref="selected" :model="selected" label-position="left" label-width="150px">
                <el-form-item label="Name" prop="name">
                  <el-input v-model="selected.name" />
                </el-form-item>
                <el-form-item label="Username" prop="username">
                  <el-input v-model="selected.username" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveInfo">Save</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="Security" name="second">
              <el-form ref="selected" :model="selected" label-position="left" label-width="150px">
                <el-form-item label="New password" prop="name">
                  <el-input v-model="selected.password" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="savePassword">Save</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="Picture" name="third">
              <uploader-component
                :avatar="true"
                :upload-path="fileUploadPath"
                @setAttachment="changePicture($event)"/>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Notification } from 'element-ui'
import { UploaderComponent } from '../layout/components'
import { UpdateInfo, UpdatePassword } from '../../api/login'

export default {
  name: 'UserProfile',
  components: { UploaderComponent },
  data() {
    return {
      activeName: 'first',
      selected: null,
      imageUrl: '',
      acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
      headers: null,
      fileUploadPath: this.$store.getters.upload_avatar
    }
  },
  created: function() {
    this.getUser()
  },
  methods: {
    getUser() {
      this.selected = this.$store.getters.user.currentUser
      this.imageUrl = this.selected.avatar
    },
    saveInfo() {
      UpdateInfo({ username: this.selected.username, name: this.selected.name }).then(res => {
        Notification.success({
          title: 'Success',
          message: 'Info updated successfully',
          duration: 4 * 1000
        })
      }).catch(error => {
        console.log(error)
      })
    },
    savePassword() {
      UpdatePassword({ password: this.selected.password }).then(res => {
        Notification.success({
          title: 'Success',
          message: 'Password updated successfully',
          duration: 4 * 1000
        })
      }).catch(error => {
        console.log(error)
      })
    },
    changePicture(path) {
      this.selected.avatar_path = path
      Notification.success({
        title: 'Success',
        message: 'Picture uploaded successfully',
        duration: 4 * 1000
      })
    }
  }
}
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
